import {
    reducer as DashboardReducer,
    actions as DashboardActions,
    actionTypes as DashboardActionTypes,
    selectors as DashboardSelectors
} from './Dashboard';

import {
    reducer as SettlementReducer,
    actions as SettlementActions,
    actionTypes as SettlementActionTypes,
    selectors as SettlementSelectors
} from './Settlement';

import {
    reducer as SpotReducer,
    actions as SpotActions,
    actionTypes as SpotActionTypes,
    selectors as SpotSelectors
} from './Spot';

import {
    reducer as ForwardReducer,
    actions as ForwardActions,
    actionTypes as ForwardActionTypes,
    selectors as ForwardSelectors
} from './Forward';

import {
    reducer as CurrencyReducer,
    actions as CurrencyActions,
    actionTypes as CurrencyActionTypes,
    selectors as CurrencySelectors
} from './Currency';

import {
    reducer as CurrencyPairReducer,
    actions as CurrencyPairActions,
    actionTypes as CurrencyPairActionTypes,
    selectors as CurrencyPairSelectors
} from './CurrencyPair';

import {
    reducer as DownloadReducer,
    actions as DownloadActions,
    actionTypes as DownloadActionTypes,
    selectors as DownloadSelectors
} from './Download';

import {
    actions as ReloadActions,
    actionTypes as ReloadActionTypes,
} from './Reload';

export const actions = {
    Dashboard: DashboardActions,
    Settlement: SettlementActions,
    Spot: SpotActions,
    Forward: ForwardActions,
    Currency: CurrencyActions,
    CurrencyPair: CurrencyPairActions,
    Download: DownloadActions,
    Reload: ReloadActions
};

export const actionTypes = {
    Dashboard: DashboardActionTypes,
    Settlement: SettlementActionTypes,
    Spot: SpotActionTypes,
    Forward: ForwardActionTypes,
    Currency: CurrencyActionTypes,
    CurrencyPair: CurrencyPairActionTypes,
    Download: DownloadActionTypes,
    Reload: ReloadActionTypes
};

export const reducerArray = [
    SettlementReducer,
    SpotReducer,
    ForwardReducer,
    DashboardReducer,
    CurrencyReducer,
    CurrencyPairReducer,
    DownloadReducer
];

export const selectors = {
    Settlement: SettlementSelectors,
    Spot: SpotSelectors,
    Forward: ForwardSelectors,
    Dashboard: DashboardSelectors,
    Currency: CurrencySelectors,
    CurrencyPair: CurrencyPairSelectors,
    Download: DownloadSelectors
};